<template>
  <div class="container type-multirange">
    <iswitch
      v-model="budget.type"
      name="switch"
      :choices="data.items"
    ></iswitch>
    <range
      v-model.number="budget.monthly"
      ref="monthly"
      :data="data.items.monthly"
      currency="€"
      :info="{ val: budget.sqm, unit: data.items.sqm.unit }"
    />
    <range
      v-model.number="budget.sqm"
      ref="sqm"
      :data="data.items.sqm"
      currency="€"
      :info="{ val: budget.monthly, unit: data.items.monthly.unit }"
    />
  </div>
</template>

<script>
import Switch from "@/components/Switch.vue";
import Range from "@/components/inputs/Range.vue";

export default {
  name: "Multirange",
  components: {
    iswitch: Switch,
    range: Range
  },
  props: ["data", "value"],
  data() {
    return {
      budget: this.value || {
        type: "monthly",
        monthly: this.data.items.monthly.min,
        sqm: this.data.items.sqm.min
      }
    };
  },
  mounted() {
    this.setActive();
    this.changeValue();
  },
  methods: {
    setActive() {
      Object.keys(this.data.items).forEach(key => {
        this.$refs[key].$el.classList.remove("active");
      });
      this.$refs[this.budget.type].$el.classList.add("active");
    },
    changeValue() {
      this.$emit("input", this.budget, this.data.name);
    }
  },
  watch: {
    "budget.type"() {
      this.setActive();
    },
    "budget.monthly"() {
      this.budget.sqm =
        Math.ceil(
          (this.budget.monthly / this.$store.getters.getAnswerBySlug("meret")) *
            10
        ) / 10;
      // this.$emit("input", this.budget, this.data.name);
    },
    "budget.sqm"() {
      this.budget.monthly =
        Math.ceil(
          this.budget.sqm * this.$store.getters.getAnswerBySlug("meret") * 10
        ) / 10;
      // this.$emit("input", this.budget, this.data.name);
    },
    budget: {
      handler() {
        this.changeValue();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.type-multirange {
  display: flex;
  flex-direction: column;

  .container {
    display: none !important;
    &.active {
      display: flex !important;
    }
  }

  /*.input-holder {
    border-radius: 0.6rem;
    background: $white;
    overflow: hidden;
    display: flex;
    align-items: center;
  }*/
  /*  .value {
    font-family: $title;
    font-size: 7rem;
    line-height: 8.5rem;
  }*/
}
</style>
